export default __webpack_public_path__ + "static/artemis-konsole-63d7f70a355fad503b4c2be12cfdeacf.png";